import { Col, Container, Row } from "react-bootstrap";
import { Button, IconMinus, IconPlus, Table, TextBox, Tabs } from '@veneer/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BulkUploads from './bulk-uploads';
import "../profile-settings/profile-settings.scss";
import './bulk-upload-tabs.css';
import BulkUploadStatus from "./bulk-upload-status";
import { setLoading } from "@store/reducers/loadingSlice";
import { POST_CREATE_CASE_LOAD } from "services";
import { apiPost } from "@services/service";
import Loader from "../shared-components/loader/loader";
import { AdminRole } from "utils";




const BulkUploadTabs: React.FC = () => {
    const { t } = useTranslation();
    //const adminRole: boolean = (window as any).IsAdmin || false;
    const [activeTab, setActiveTab] = useState(0);
    const [progress, setProgress] = useState(false);
    const [savedContact, setSavedContact] = useState<any>([]);
    const [siteSubAccount, setSiteSubAccount] = useState<any>([]);

    const changeTabHandler = (id: any) => {
        setActiveTab(id);
    };

    useEffect(() => {
        if (!AdminRole) {
            return;
        }

        fetchData();
    }, [])

    const fetchData = async (showfavonlyopt = false) => {
        setLoading(true);
        setProgress(true);
        try {
            try {
                const payload = {
                    contactid: "85680C15-7814-E711-80FC-5065F38AD971"
                };
                const response = await apiPost(POST_CREATE_CASE_LOAD, payload);
                if (response && response.data) {
                    let SavedContactsDropDown = JSON.parse(response.data.SavedContactsDropDown);
                    let siteSubAccount = JSON.parse(response.data.siteSubAccount);
                    let formatedDropdown =
                        SavedContactsDropDown.map(({ Value, Key }: any) => ({
                            label: Value,
                            value: Key,
                        }));
                    let formatedsiteSubAccount =
                        siteSubAccount.map(({ Value, Key }: any) => ({
                            label: Value,
                            value: Key,
                        }));
                    setSavedContact([{ label: t('HPI.Dropdown.SelectSavedContact', { defaultValue: 'create a new contact' }), value: "-1" }, ...formatedDropdown]);
                    setSiteSubAccount(formatedsiteSubAccount);
                }
                setLoading(false);
                setProgress(false);


            } catch (error) {
                setProgress(false);
            }
        } catch (err) {
            setLoading(false);
            setProgress(false);
        }
    };

    return (
        !AdminRole ? null :
        <Container fluid className="profile-setting-container">
            {progress && (
                <div className="loader-overlay">
                    <div className="loader-css">
                        <Loader />
                    </div>
                </div>
            )}
            <div className="profile-inner">
                {/* <div className="header">
                    <h2>{"Bulk Upload Management"}</h2>
                </div> */}
                <div>
                   
                        <Row>
                            
                            <Col sm={12} className="mt-3">
                                <Tabs
                                    controlId="default"
                                    mode="contained"
                                    onChangeTab={changeTabHandler}
                                    selectedTabId={activeTab}
                                    tabs={[
                                        {
                                            id: 0,
                                            label: t("HPI.Profilepage.tab.Bulkupload", { defaultValue: 'Bulk upload' }),
                                            content: (
                                                <div>
                                                    <BulkUploads
                                                        dropdown={savedContact} siteSubAccount={siteSubAccount} />
                                                </div>
                                            ),
                                        },
                                        {
                                            id: 1,
                                            label: "Bulk upload Status",
                                            content: (
                                                <div>
                                                    <BulkUploadStatus />
                                                </div>
                                            ),
                                        },

                                    ]}
                                    type="attached"
                                />
                            </Col>
                        </Row>
                </div>
            </div>
        </Container>
    );
};
export default BulkUploadTabs;
